

























import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { IState } from "@/store";
import { mapState } from "vuex";
import { DataModules } from "@/store/modules/data";
import { IWalletBalance } from "@/models/wallets";
import CurrenciesStore from "@/mixins/constants/currenciesStore";
import { IAccount } from "@/models/accounts";
import { ICurrency } from "@/models/constants";

@Component({
  computed: {
    ...mapState({
      dataScope(state: IState, getters) {
        return getters[`data/${this.dataModule}/balanceScope`](this.accountId);
      },
      wallet(state, getters) {
        return getters[`data/single`]({
          storeModule: this.dataModule,
          scope: this.dataScope
        });
      }
    })
  }
})
export default class WalletInput extends Mixins(
  RequestPromises,
  CurrenciesStore
) {
  @Prop({ required: true })
  public currencyId!: ICurrency["id"];
  @Prop({ required: false })
  public value!: number;
  @Prop({ default: "" })
  public accountId!: IAccount["id"];
  @Prop({ default: null })
  public max!: number;
  @Prop({ default: false })
  public disabled!: number;
  public wallet!: IWalletBalance;
  public dataScope!: string;
  public dataModule = DataModules.WALLETS;
  // Data
  public isLoading = true;
  public isReloading = false;
  public requestError = false;
  public canSeeWallet = this.$userCan("wallet_admin_get_balance");

  public get currency() {
    if (!this.currenciesLoaded) {
      return {};
    }
    return this.$_.find(this.currencies, ["id", this.currencyId]);
  }

  public reloadData() {
    this.isReloading = true;
    this.getBalance();
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binSingle", {
      storeModule: this.dataModule,
      scope: this.dataScope,
      vm: this
    });
  }

  public async getBalance() {
    try {
      await this.$store.dispatch(`data/${this.dataModule}/balance`, {
        scope: this.dataScope,
        ignoreStored: true,
        accountId: this.accountId,
        params: {
          currency_id: this.currencyId
        },
        vm: this
      });
      this.requestError = false;
    } catch (error) {
      this.requestError = true;
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.$emit(
        "update:amountAvailableFormatted",
        this.$_.get(
          this.wallet,
          `total.${this.currencyCode}.amount_converted_formatted`,
          ""
        )
      );
      this.$emit(
        "update:amountAvailable",
        this.$_.toNumber(
          this.$_.get(
            this.wallet,
            `total.${this.currencyCode}.amount_converted`
          )
        )
      );
      this.$emit("wallet-loaded");
      this.isLoading = false;
      this.isReloading = false;
    }
  }

  public get currencyCode() {
    return this.$_.get(this.currency, "code");
  }

  public get maxWalletAmount() {
    if (!this.currencyCode) return this.max;
    const maxFromWallet = this.wallet.total[this.currencyCode].amount_converted;
    if (this.max === null || maxFromWallet < this.max) {
      return maxFromWallet < 0 ? 0 : maxFromWallet; // Possible negative value (BE bug)
    }
    return this.max < 0 ? 0 : this.max; // Possible negative value (BE bug)
  }

  @Watch("currenciesLoaded")
  public currenciesLoadedWatcher() {
    this.getBalance();
  }

  @Watch("currencyId", { immediate: true })
  public onCurrencyChange() {
    if (!this.canSeeWallet) return;
    this.isLoading = true;
    if (this.currenciesLoaded) {
      this.getBalance();
    }
  }
}
